/* global axios */
import ApiClient from './ApiClient';
import { requestConfig } from './lais/httpHelpers';

class SalesTransactionPartiesAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  list(transactionId, params = {}) {
    return axios.get(`${this.url}/${transactionId}/parties`, {
      ...requestConfig(),
      params,
    });
  }

  catalog(transactionId) {
    return axios.get(
      `${this.url}/${transactionId}/parties/catalog`,
      requestConfig()
    );
  }

  show(transactionId, partyId) {
    return axios.get(
      `${this.url}/${transactionId}/parties/${partyId}`,
      requestConfig()
    );
  }

  create(transactionId, payload) {
    return axios.post(
      `${this.url}/${transactionId}/parties`,
      payload,
      requestConfig()
    );
  }

  update(transactionId, partyId, payload) {
    return axios.patch(
      `${this.url}/${transactionId}/parties/${partyId}`,
      payload,
      requestConfig()
    );
  }

  saveBlock(transactionId, partyId, payload) {
    return axios.post(
      `${this.url}/${transactionId}/parties/${partyId}/save_block`,
      payload,
      requestConfig()
    );
  }

  remove(transactionId, partyId) {
    return axios.delete(
      `${this.url}/${transactionId}/parties/${partyId}`,
      requestConfig()
    );
  }

  lookup(transactionId, cpf) {
    return axios.post(
      `${this.url}/${transactionId}/parties/lookup`,
      { cpf },
      requestConfig()
    );
  }

  checkLaborCertificate(transactionId, partyId) {
    return axios.post(
      `${this.url}/${transactionId}/parties/${partyId}/labor_certificate_check`,
      {},
      requestConfig()
    );
  }
}

export default new SalesTransactionPartiesAPI();
